/** Poca 페이지에서 조회하는 고정 vendor (섹션 설정과 무관). */
export const POCA_VENDOR = "PC";

export type PocaConfig = {
  vendor: string;
  storefrontDomain: string;
  storefrontAccessToken: string;
  storefrontApiVersion: string;
  pageSize: number;
  enableSearch: boolean;
  enableSort: boolean;
  enablePriceFilter: boolean;
  enableAvailabilityFilter: boolean;
  enableAddToCart: boolean;
  /** 수량 할인 배너(Poca Vault Exclusive Sale) 노출. 프로모션을 잠시 접었다 다시 열 때 테마 에디터에서 끄고 켠다 */
  showBulkDeal: boolean;
  /**
   * 표시용 할인율(%). 0 이면 꺼짐.
   *
   * <p>할인 앱(Discount Mixer)이 커스텀 카드를 인식 못 해서 표기는 우리가 직접 그린다.
   * 실제 할인은 앱이 체크아웃에서 적용하므로, 이 값은 앱에 설정한 할인율과 손으로 맞춰야 한다.
   */
  discountPercent: number;
  /** 할인 뱃지에 붙는 라벨 (예: SALE) */
  discountLabel: string;
  currencyCode: string;
  countryCode: string;
  locale: string;
  routesCartAdd: string;
  /**
   * 상단 컬렉션 슬라이더: title 이 이 prefix 로 시작하는 컬렉션 전체를 이름순으로 노출.
   * 예: "PC_". 빈 문자열이면 prefix 필터를 적용하지 않음.
   */
  collectionTitlePrefix: string;
};

export type Money = {
  amount: string;
  currencyCode: string;
};

export type ProductVariant = {
  id: string;
  title: string;
  availableForSale: boolean;
  price: Money;
  compareAtPrice: Money | null;
};

export type ProductImage = {
  url: string;
  altText: string | null;
  width: number;
  height: number;
};

export type Product = {
  id: string;
  handle: string;
  title: string;
  vendor: string;
  availableForSale: boolean;
  tags: string[];
  featuredImage: ProductImage | null;
  images: ProductImage[];
  priceRange: { minVariantPrice: Money; maxVariantPrice: Money };
  compareAtPriceRange: { minVariantPrice: Money; maxVariantPrice: Money };
  variants: ProductVariant[];
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor: string | null;
};

export type Collection = {
  id: string;
  handle: string;
  title: string;
  image: { url: string; altText: string | null } | null;
  latestProductCreatedAt?: string | null;
};

export type SortKey =
  | "RELEVANCE"
  | "BEST_SELLING"
  | "CREATED_AT"
  | "PRICE"
  | "TITLE";

export type SortOption = {
  key: SortKey;
  reverse: boolean;
  label: string;
};

export type ProductDetailData = Product & {
  descriptionHtml: string;
};

declare global {
  interface Window {
    __POCA_CONFIG__?: PocaConfig;
  }
}
